import React from 'react'
import { connect } from 'react-redux'

/* Components */
import DashboardEliteserien from './DashboardEliteserien'
import DashboardToppserien from './DashboardToppserien'
import DashboardLiga from './DashboardLiga'
import DashboardSponsor from './DashboardSponsor'
import DashboardSponsorPA from './DashboardSponsorPA'
import DashboardPerson from './DashboardPerson'
import DashboardAssociation from './DashboardAssociation'
import DashboardBetsson from './DashboardBetsson'

const BETSSON_TENANT_ID = 179;

const Dashboard = ({ tenant }) => {
  // Betsson gets a simplified dashboard
  if (tenant.template === 'association' && tenant.id === BETSSON_TENANT_ID) {
    return <DashboardBetsson />;
  }

  const hasPlacementAnalysis = tenant.features?.['placement-analysis'];
  const SponsorDashboard = (tenant.template === 'sponsor' && hasPlacementAnalysis)
    ? DashboardSponsorPA
    : DashboardSponsor;

  return (
    <>
      {
        {
          'eliteserien': <DashboardEliteserien />,
          'league': <DashboardLiga />,
          'obosligaen': <DashboardEliteserien />,
          'toppserien': <DashboardToppserien />,
          'sponsor': <SponsorDashboard />,
          'person': <DashboardPerson />,
          'empty': <></>,
          'association': <DashboardAssociation />,
        }[tenant.template]
      }
    </>
  );
}

const mapStateToProps = state => ({
  tenant: state.auth.tenant
})

export default connect(mapStateToProps, {})(Dashboard)
